export const coverageTypes = [
  'General Medical',
  'Dental',
  'Optical',
  'Inpatient',
  'Outpatient',
  'Maternity',
  'Pediatric',
  'Physiotherapy',
  'Chronic Diseases',
  'Mental Health',
  'Emergency',
  'Vaccination',
  'Extended Healthcare',
  'Basic',
  'Vip',
  'Other'
]

export const coverageRelationships = [
  'Self',
  'Spouse',
  'Child',
  'Son',
  'Daughter',
  'Father',
  'Mother',
  'Brother',
  'Sister',
  'Grandfather',
  'Grandmother',
  'Uncle',
  'Aunt',
  'Cousin',
  'Nephew',
  'Niece',
  'Employee',
  'Dependent',
  'Other'
]
